<div class="modal-dialog">
  <div class="modal-content">
    <div class="modal-header">Restore from archive</div>
    <div class="modal-body cl-form">

      <p class="mb-3">You are about to restore or change the restore parameter of the following files:</p>

      <div class="files-table-scroll">
        <table class="cl-table-data cl-table-data-light">
          <thead>
            <tr>
              <th class="cl-table-head cl-p-tiny">Name</th>
              <th class="cl-table-head cl-p-tiny">Size</th>
              <th class="cl-table-head cl-p-tiny">Restoration Plan</th>
            </tr>
          </thead>
          <tbody>
            @for (file of data.files; track file) {
              <tr>
                <td class="">{{ file.name }}</td>
                <td class="" style="width: 70px">{{ file.size | fileSize }}</td>
                <td class="">{{ file | fileRestorePlan:selectedTier }}</td>
              </tr>
              }
            </tbody>
          </table>
        </div>


        <label class="form-label mt-3" for="days">Days to keep restored</label>
        <input id="days" class="form-control" type="number" [(ngModel)]="days" min="1">

        <label class="form-label mt-3">Please select a restore tier (affects the cost and restoration time).</label>

        <dl class="cl-dl cl-tight form-check px-0">
          @for (tier of tiers; track tier.tier) {
            <dt>
              <div class="form-check">
                <input [value]="tier.tier" [(ngModel)]="selectedTier" class="form-check-input" type="radio" name="tier" [id]="'radio-' + tier.tier">
                <label class="form-check-label" [for]="'radio-' + tier.tier">{{ tier.label }}</label>
              </div>
            </dt>
            <dd>{{ tier.description }}</dd>
          }
        </dl>

        @if (selectedTier === RestoreTier.RestoreTier_1) {
          <p class="mt-3">To confirm your intention, please type <code>confirm</code> into this text field:</p>
          <input id="confirmfield" type="text" class="mt-3 text-center" [(ngModel)]="confirmText" style="width: 100%;">
        }

      </div>
      <div class="modal-footer">
        <span class="modal-footer-left "><button class="btn cl-color-secondary it-cancel"
          (click)="dialogRef.close()"><span>Cancel</span></button></span>
          <span class="modal-footer-right ">
            <button class="btn cl-color-primary" [class.cl-btn-spinner]="startedrestoring"
              (click)="startRestore()"
              [disabled]="startedrestoring || (selectedTier === RestoreTier.RestoreTier_1 && confirmText !== 'confirm')"><span>Accept and restore</span></button>
          </span>
        </div>


      </div>
    </div>
